
export function dateWithNoTime(date?: Date | string) {
    const finalDate = date ? new Date(date) : new Date();

    finalDate.setHours(0, 0, 0, 0);

    return finalDate;
}

export function dateWithTime(date?: Date | string | null, time?: string | null, timezone?: string | null): Date {
    let finalDate: Date;

    if (date != undefined && typeof date === 'string') {
        finalDate = new Date(date);
    } else if (date != undefined && date instanceof Date) {
        finalDate = date
    } else {
        finalDate = new Date();
    }

    if (time) {
        let hours: number;
        let minutes: number;

        if (time.includes('T')) {
            const timePart = time.split('T')[1].split('.')[0]; 
            [hours, minutes] = timePart.split(':').map(Number);
        } else {
            [hours, minutes] = time.split(':').map(Number);
        }

        finalDate.setHours(hours, minutes, 0, 0);
    }

    if (timezone && timezone !== "local") {
        const formatter = new Intl.DateTimeFormat([], {
            timeZone: timezone,
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            hour12: false,
        });

        const parts = formatter.formatToParts(finalDate);
        const dateComponents = {} as Record<string, number>;

        parts.forEach(({ type, value }) => {
            if (type !== 'literal') {
                dateComponents[type] = Number(value);
            }
        });

        finalDate.setFullYear(dateComponents.year);
        finalDate.setMonth(dateComponents.month - 1);
        finalDate.setDate(dateComponents.day);
        finalDate.setHours(dateComponents.hour, dateComponents.minute, dateComponents.second, 0);
    }

    return finalDate;
}